var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgBellOff16 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bellOff16_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.208,
    clipPath: "url(#bellOff16_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.045 13.438a1.209 1.209 0 0 1-2.09 0M12.005 8.604a10.808 10.808 0 0 1-.38-3.021M4.532 4.532a3.54 3.54 0 0 0-.157 1.051c0 4.23-1.812 5.438-1.812 5.438h8.458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.625 5.584a3.626 3.626 0 0 0-5.637-3.021M1.354 1.354l13.291 13.292"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bellOff16_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bellOff16_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.75.75h14.5v14.5H.75z"
  })))));
});
SvgBellOff16.displayName = "SvgBellOff16";
export default SvgBellOff16;